import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SelectMultiple from "src/components/SelectMultiple/SelectMultiple";
import { expandJSON } from "src/helpers/helper";
import { AET_DASHBOARD } from "src/redux/config/links";

const SelectCompany = ({
  selectedCompany,
  onChangeSelectedCompany,
  onRemoveSelectedCompany,
}) => {
  const { authStore } = useSelector((state) => ({
    authStore: state.authStore,
  }));
  const [oneTime, setOneTime] = useState(true);

  const onCompanyList = useCallback(
    ({ page, sort, filter, show = [], groupby = [] }) => {
      setLoadingCompany(true);
      let newFilter = {};
      Object.keys(filter).forEach((item) => {
        newFilter = { ...newFilter, [item]: encodeURI(`%${filter[item]}%`) };
      });

      const query = expandJSON({ page, sort, filter: newFilter, show, groupby })
        .map((item) => `${item.label}=${item.value}`)
        .join("&");
      axios({
        url: `${AET_DASHBOARD}?${query}`,
        method: "POST",
        headers: {
          Authorization: authStore.authData.result.token,
        },
      })
        .then((result) => {
          setLoadingCompany(false);
          setCompanyList(result.data);
        })
        .catch(() => {
          setLoadingCompany(false);
        });
    },
    [authStore.authData.result.token]
  );

  const [filterCompany, setFilterCompany] = useState([]);
  const [pageCompany, setPageCompany] = useState({
    of: 1,
    size: 20,
  });
  const [loadCompany, setLoadCompany] = useState(false);
  const [companyList, setCompanyList] = useState(null);
  const [isLoadingCompany, setLoadingCompany] = useState(false);

  useEffect(()=>{
    if(oneTime){
        setOneTime(false);
        setLoadCompany(true)
    }
  },[oneTime])
  useEffect(() => {
    if (loadCompany) {
      setLoadCompany(false);
      onCompanyList({
        page: pageCompany,
        sort: [],
        filter: filterCompany,
        show: ["leftJoin_company_name"],
        groupby: ["leftJoin_company_name"],
      });
    }
  }, [filterCompany, pageCompany, loadCompany, onCompanyList]);

  return (
    <>
      <SelectMultiple
        placeholder="Company"
        name={"company"}
        onChange={(e, selectedItem)=>onChangeSelectedCompany(e, selectedItem, companyList)}
        option={[
          { label: "All", value: "All" },
          ...(!!companyList ? [...companyList.result.data] : []).map(
            (item) => ({
              label: item.leftJoin_company_name,
              value: item.leftJoin_company_name,
            })
          ),
        ]}
        value={selectedCompany}
        page={pageCompany}
        totalPage={
          Math.ceil(
            ((!!companyList ? companyList.result.total : 1) ?? 1) /
              pageCompany.size
          ) ?? 1
        }
        onPage={(page) => {
          setPageCompany(page);
          setLoadCompany(true);
        }}
        onKeypress={(value) => {
          setFilterCompany({
            ...filterCompany,
            leftJoin_company_name: `${value}`,
          });
          setLoadCompany(true);
        }}
        loading={isLoadingCompany}
      />
      
      {selectedCompany.map((item, index) => (
        <React.Fragment key={index}>
          <button
            onClick={()=>onRemoveSelectedCompany(item)}
            className="btn btn-primary"
            type="button"
          >
            {item.label} <span aria-hidden="true">&times;</span>
          </button>{" "}
        </React.Fragment>
      ))}
    </>
  );
};

export default SelectCompany;
